export default __webpack_public_path__ + "static/100--stacked-area-43320dd94c77e49c6253749f578572f2.png";